/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PersonMissing } from "./PersonMissing";
import type { TemplatePerson } from "./TemplatePerson";

/**
 * The wording filled in for one person.
 */
export type TemplatePreview = {
  person?: TemplatePerson | null;
  subject: string;
  html: string;
  text: string;
  sms: string;
  sms_characters: number;
  sms_segments: number;
  sms_encoding: TemplatePreview.sms_encoding;
  missing: Array<string>;
  unknown: Array<string>;
  others_missing?: Array<PersonMissing>;
  unsubscribed?: Array<string>;
  removed?: string | null;
  size_note?: string | null;
};

export namespace TemplatePreview {
  export enum sms_encoding {
    GSM_7 = "GSM-7",
    UNICODE = "Unicode",
  }
}
